import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import placeholderImg from "../assets/images/new/aboutUsPageBatuk.png";
function SuccessModal({ show, onHide, onConfirm, Action }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      keyboard={false}
      centered
    >

      <Modal.Title
        style={{ fontSize: "25px", fontWeight: "bold" }}
      ></Modal.Title>
      <Modal.Body
        style={{
          backgroundColor: "#f2eeee",
          color: "Black",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          minHeight: "80px", // Ensures proper vertical centering
        }}
      >
        <span style={{ fontSize: "20px" }}>

          <img
            src={placeholderImg}
            alt="Puja-Img"
            className="puja-img"
            style={{ height: '11em', width: '9em' }}
          />
          <br />
          <p style={{ fontSize: "16px", textAlign: 'justify' }}>
            {Action === 'Contact' ? 'Thank you for contacting us. Our team will reach out to you shortly.' : <span className="text-center">Thank you for subscribing to our newsletter. <br></br>We will keep you informed with the latest updates.</span>}
          </p>
        </span>
      </Modal.Body>
      <Modal.Footer style={{ backgroundColor: "#f2eeee" }}>
        {/* <Button
          variant="secondary"
          onClick={onHide}
          style={{ backgroundColor: "#A52444", border: "none" }}
        >
          NO
        </Button> */}
        <Button
          variant="primary"
          onClick={onConfirm}
          style={{
            backgroundColor: "#ff9900",
            color: "#2B1B10",
            border: "none",
            color: "#000000",
            padding: "10px 15px",
            cursor: 'pointer'
            , fontSize: '14px',
            fontWeight: 'bold'
          }}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SuccessModal;
